﻿import { navigationMenuState } from './navigationMenu';

export const controls = {
	navigationMenuState
};